const config = {
  initiateLoginEndpoint: process.env.REACT_APP_START_LOGIN_PAGE_URL,
  clientId: process.env.REACT_APP_CLIENT_ID,
  apiEndpoint: process.env.REACT_APP_BOT_FUNCTION_ENDPOINT,
  cosmosApiEndpoint: process.env.REACT_APP_BOT_FUNCTION_ENDPOINT,
  functionApiEndpoint: process.env.REACT_APP_FUNC_ENDPOINT,
  cosmosApiEnabled: process.env.REACT_APP_COSMOS_API_ENABLED === "true",
  apiGetProjectInfosName: process.env.REACT_APP_FUNC_GETPROJECTINFOS_NAME,
  apiRunAuditLog: process.env.REACT_APP_FUNC_RUNAUDITLOG_NAME,
  apiRemoveSPOSite: process.env.REACT_APP_FUNC_REMOVESPOSITE,
  apiAddSpoOwner: process.env.REACT_APP_FUNC_ADDSPOOWNER,
  apiRemoveProjectUser: process.env.REACT_APP_FUNC_REMOVEPROJECTUSER,
  apiRemoveProjectOwner: process.env.REACT_APP_FUNC_REMOVEPROJECTOWNER,
  apiReplaceProjectOwner: process.env.REACT_APP_FUNC_REPLACEPROJECTOWNER,
  apiRemoveProjectSiteCollectionAdministrator: process.env.REACT_APP_FUNC_REMOVEPROJECTSITECOLLADMIN,
  apiReplaceProjectSiteCollectionAdministrator: process.env.REACT_APP_FUNC_REPLACEPROJECTSITECOLLADMIN,
  botFunctionEndPoint: process.env.REACT_APP_BOT_FUNCTION_ENDPOINT,
  botDomain: process.env.REACT_APP_BOT_DOMAIN,
  apiBotNotification: process.env.REACT_APP_FUNC_BOTNOTIFICATION,
  apimEndpoint: process.env.REACT_APP_APIM_ENDPOINT,
  apimGraphProxy: process.env.REACT_APP_APIM_GRAPH_PROXY,
  apimCheckConsent: process.env.REACT_APP_APIM_CHECKCONSENT,
  queueWrapperEndpoint: process.env.REACT_APP_FUNC_ENDPOINT
    ? `${process.env.REACT_APP_FUNC_ENDPOINT.replace(/\/+$/, "")}/api/${process.env.REACT_APP_FUNC_QUEUE_WRAPPER ?? "queue"}`
    : undefined,
  queueWrapperScope: process.env.REACT_APP_QUEUE_WRAPPER_SCOPE,
};

export default config;
